import Emitter from 'events'

export default new Emitter()
